import React, { useEffect, useLayoutEffect } from "react";
import Layout from "../../layout/Layout";
import DashBoardCard from "../../card/dashboardCard/DashBoardCard";
import j1 from "../../../assets/svg/job-one-p.svg";
import j2 from "../../../assets/svg/job-two-p.svg";
import j3 from "../../../assets/svg/job-three-p.svg";
import a1 from "../../../assets/svg/earning-one.svg";
import a2 from "../../../assets/svg/earning-two.svg";
import a3 from "../../../assets/svg/earning-three.svg";
import a4 from "../../../assets/svg/earning-four.svg";
import a5 from "../../../assets/svg/earning-five.svg";

import EarningCard from "../../card/dashboardCard/EarningCard";
import axios from "axios";
import { BASE_URL } from "../../../customHooks/config";
import { useLocation } from "react-router-dom";
import useDashboard from "../../../customHooks/useDashboard";
import Spinner from "../../layout/loader/Spinner";

function Dashboard() {
  const [myEarning, jobsData, loadingEarning] = useDashboard();

  const job = [
    {
      icon: j1,
      bgColor: "#DEE7FC",
      title: "My Jobs",
      number: `${jobsData?.my_jobs_count ?? 0}`,
      link: "/all-jobs/1",
    },
    {
      icon: j2,
      bgColor: "#FDE7BC",
      title: "New Jobs",
      number: `${jobsData?.pending_job_count ?? 0}`,
      link: "/all-jobs/2",
    },
    {
      icon: j3,
      bgColor: "#FFE2E2",
      title: "Rejected Jobs",
      number: `${jobsData?.rejected_job_count ?? 0}`,
      link: "/all-jobs/3",
    },
  ];

  const earning = [
    {
      icon: a1,
      title: "Projected Earning",
      link: "/my-earning/",
      number: `₹${
        myEarning?.projected_earning?.projected_amount.toLocaleString(
          "en-IN"
        ) ?? 0
      }`,
    },
    {
      icon: a2,
      title: "Net Earning",
      link: "/my-earning/",
      number: `₹${
        myEarning?.net_earning?.joined_amount.toLocaleString("en-IN") ?? 0
      }`,
    },
    {
      icon: a3,
      title: "Mature Earning",
      link: "/my-earning/",
      number: `₹${
        myEarning?.matured_earning?.matured_amount.toLocaleString("en-IN") ?? 0
      }`,
    },
    {
      icon: a4,
      title: "Withdrawable",
      link: "/my-earning/",
      // process: "In Progress",
      number: `₹${
        myEarning?.withdrawable_earning?.withdrawable_amount.toLocaleString(
          "en-IN"
        ) ?? 0
      }`,
    },
    {
      icon: a5,
      title: "Total Withdrawn",
      link: "/my-earning/",
      number: `₹${
        myEarning?.total_withdrawn_amount?.toLocaleString("en-IN") ?? 0
      }`,
    },
  ];

  return (
    <>
      <div className="w-full pt-2 pb-8 ">
        <div>
          <h2 className="text-[#585562] text-sm mb-4 ">Jobs</h2>
        </div>
        <div className="flex flex-wrap ">
          {job.map((item, i) => (
            <div className="w-[150px] h-[150px] mr-16 mb-10 grid" key={i}>
              <DashBoardCard
                icon={item.icon}
                title={item.title}
                number={item.number}
                link={item.link}
                iconColor={item.iconColor}
                bgColor={item.bgColor}
              />
            </div>
          ))}
        </div>

        {/* <div>
            <h2 className="text-[#585562] text-sm mb-4 ">Applicants</h2>
          </div>
          <div className="flex flex-wrap ">
            {applicant.map((item, i) => (
              <div className="w-[150px] h-[150px] mr-10 mb-10 grid" key={i}>
                <DashBoardCard
                  icon={item.icon}
                  title={item.title}
                  number={item.number}
                  progress={item.process}
                />
              </div>
            ))}
          </div> */}

        <div>
          <h2 className="text-[#585562] text-sm mb-4 ">Earning</h2>
        </div>
        {/* <div>
          <EarningCard myEarning={myEarning} />
        </div> */}
        <div className="flex flex-wrap ">
          {earning.map((item, i) => (
            <div className="w-[150px] h-[150px] mr-16 mb-10 grid" key={i}>
              <DashBoardCard
                icon={item.icon}
                title={item.title}
                link={item.link}
                number={item.number}
                progress={item.process}
              />
            </div>
          ))}
        </div>
      </div>
      {/* </Layout> */}
    </>
  );
}

export default Dashboard;
